import React from 'react';

function Header() {
  return <header className="header">COVID-19 Dashboard</header>;
}

export default Header;
